import React from 'react';
import './Illustrations.css';

/**
 * A fox portrait (head and shoulders) for a person on the contact cards, in the same style as
 * Revetall's fox but without the glasses, so the mascot stays the mascot. A few details tell
 * the people apart.
 * @param {Object} props
 * @param {boolean} [props.hair] - A dark tuft of hair between the ears
 * @param {boolean} [props.beard] - A darker beard under the mouth
 * @param {'shirt'|'sweater'} [props.top] - White shirt with a collar, or a navy sweater
 * @returns {JSX.Element} Decorative drawing
 */
function FoxPortrait({ hair = false, beard = false, top = 'shirt' }) {
  return (
    <svg className="illustration" viewBox="0 0 120 120" aria-hidden="true" focusable="false">
      {/* Shoulders */}
      {top === 'sweater' ? (
        <>
          <path className="ill-navy" d="M8 124 Q10 100 60 96 Q110 100 112 124 Z" />
          <path className="ill-line-gold" d="M44 99 Q60 108 76 99" />
        </>
      ) : (
        <>
          <path className="ill-white" d="M8 124 Q10 100 60 96 Q110 100 112 124 Z" />
          <path className="ill-line-navy" d="M8 124 Q10 100 60 96 Q110 100 112 124" />
          <path className="ill-line-navy" d="M45 98 L60 111 L75 98 M60 111 L60 124" />
        </>
      )}

      {/* Head, drawn like the big fox's head and scaled down to fit the circle */}
      <g transform="translate(-31 -8.2) scale(0.7)">
        <path className="ill-fox" d="M84 88 L86 36 Q88 26 96 32 L124 64 Z" />
        <path className="ill-fox" d="M176 88 L174 36 Q172 26 164 32 L136 64 Z" />
        <path className="ill-white" d="M92 80 L92 46 L114 68 Z" />
        <path className="ill-white" d="M168 80 L168 46 L146 68 Z" />
        <path className="ill-navy" d="M86 45 L86 36 Q88 26 96 32 L107 45 Z" />
        <path className="ill-navy" d="M174 45 L174 36 Q172 26 164 32 L153 45 Z" />

        <path className="ill-fox" d="M78 104 Q78 62 130 60 Q182 62 182 104 Q182 134 154 150 Q130 164 106 150 Q78 134 78 104 Z" />
        <path
          className="ill-white"
          d="M80 110 Q98 104 114 118 Q124 128 130 128 Q136 128 146 118 Q162 104 180 110 Q180 134 154 150 Q130 164 106 150 Q80 134 80 110 Z"
        />
        {hair && <path className="ill-navy" d="M108 66 Q118 50 130 62 Q142 50 152 66 Q130 74 108 66 Z" />}
        {beard && <path className="ill-fox-dark" d="M108 145 Q130 154 152 145 Q150 164 130 170 Q110 164 108 145 Z" />}

        <circle className="ill-navy" cx="110" cy="100" r="5.5" />
        <circle className="ill-navy" cx="150" cy="100" r="5.5" />
        <circle className="ill-white" cx="108.5" cy="98.5" r="1.8" />
        <circle className="ill-white" cx="148.5" cy="98.5" r="1.8" />
        <ellipse className="ill-cheek" cx="97" cy="124" rx="7" ry="4" />
        <ellipse className="ill-cheek" cx="163" cy="124" rx="7" ry="4" />
        <path className="ill-navy" d="M123 128 Q130 124 137 128 Q134 136 130 137 Q126 136 123 128 Z" />
        <path className="ill-line-navy" d="M124 142 Q130 147 130 140 Q130 147 136 142" />
      </g>
    </svg>
  );
}

export default FoxPortrait;
